import React, {useState} from 'react';
import "./TemplateList.css";
import NHeading1 from "../../../simple/TextComponents/NHeading1/NHeading1";
import text from "../../../../services/localization/text";
import DocumentFunctional from "../DocumentEdit/Document/DocumentFunctional";
import RenderOnReady from "../../../service/RenderOnReady/RenderOnReady";
import BtnEditAct from "../../../simple/Buttons/BtnEditAct/BtnEditAct";
import type {onIdNameClick, organizationId} from "../../../../services/flowTypes/dataFlowTypes";
import useOrganizationTemplates from "../../../../hooks/useOrganizationTemplates";

const TemplateList = ({organizationId, onTemplateClick}: {
  organizationId: organizationId,
  onTemplateClick: onIdNameClick
}) => {
  const [actual, setActual] = useState(Date.now())

  const {isReadyToRender, errorObject, data} = useOrganizationTemplates(organizationId, actual)

  const refreshData = () => {
    setActual(Date.now())
  }

  if (isReadyToRender && data.length === 0) {
    return null
  }

  return (
    <>
      <RenderOnReady isReadyToRender={isReadyToRender} errorObject={errorObject}/>
      {errorObject && <button
        className="TemplateList__error-retry"
        onClick={refreshData}
      >
        Попробовать снова
      </button>}
      <div className="TemplateList__header">
        <div className="flex_jc-sb mt_3du">
          <NHeading1>{text.availableTemplates}</NHeading1>
        </div>
        <div className="TemplateList__count">
          Всего: {data.length}
        </div>
      </div>
      <div className="TemplateList__items">
        {data.map(({id, name}) => {
          return <DocumentFunctional
            addClasses={'TemplateList__item'}
            key={id}
            itemId={organizationId}
            itemType={'organizations'}
            showTime={false}
            organizationId={organizationId}
            document={{
              id,
              name,
              fileId: id
            }}
            documentBtns={<div className="ta_r">
              <BtnEditAct id={"use-doc-" + id}
                          onClick={() => {
                            onTemplateClick({id, name})
                          }}
                          addClasses={'d_ib'}>
                {text.chooseActTemplateDoc}
              </BtnEditAct>
            </div>}
          />
        })
        }
      </div>
    </>
  );
};

export default TemplateList;
